'use client'

import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import Overlay from '../overlay'
import Icon, { IconName } from '../icon'
import Spinner, { SpinnerSize } from './spinner'

const SPINNER_TRANSITION = 300

type Props = {
  local?: boolean
  state?: 'hide' | 'show' | 'success' | 'error'
  size?: SpinnerSize
  className?: string
}

export const StatusSpinner = ({ local = false, state, size = 'lg', className = '' }: Props) => {
  const [currentState, setCurrentState] = useState(state) // buffered state
  const [show, setShow] = useState(state !== 'hide')
  const [showStatus, setShowStatus] = useState(false)
  const [enter, setEnter] = useState(true)
  const [statusEnter, setStatusEnter] = useState(false)

  useEffect(() => {
    if (!state) {
      setCurrentState(state)
      return
    }
    switch (state) {
      case 'show':
        setCurrentState(state)
        setShow(true)
        setShowStatus(false)
        setEnter(true)
        setStatusEnter(false)
        break
      case 'success':
      case 'error':
        setShow(true)
        setCurrentState(state)
        setShowStatus(true)
        setStatusEnter(true)
        break
      case 'hide':
        setEnter(false)
        setStatusEnter(false)

        setTimeout(() => {
          setCurrentState(state)
          setShow(false)
        }, SPINNER_TRANSITION)
        break
    }
  }, [state])

  if (!show) {
    return null
  }

  let icon: IconName | null = null
  if (currentState === 'success') {
    icon = 'check'
  }
  if (currentState === 'error') {
    icon = 'close'
  }

  return (
    <>
      <Overlay show={!local} />
      <div
        className={classNames(
          'c-spinner c-status-spinner',
          className,
          enter ? 'a-fade-in' : 'a-fade-out',
          {
            'c-spinner--local': local,
            'c-status-spinner--show-status': showStatus,
          },
          `c-status-spinner--${size}`
        )}>
        <Spinner local={true} size={size} />
        <div
          className={classNames(
            'c-status-spinner__status',
            `c-status-spinner__status--${currentState}`
          )}>
          <div className="c-status-spinner__status-inner">
            {showStatus && icon && (
              <Icon
                name={icon}
                className={classNames(
                  'c-status-spinner__status-icon',
                  statusEnter ? 'a-fade-in' : 'a-fade-out'
                )}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
